import React from 'react';
import Styles from './actualites.module.scss';
import IActualite from 'model/actualite';
import ActualiteCard from './actualiteCard';
import ActualitesService from 'services/actualitesService';
import { Container, Col, Row, Button } from 'reactstrap';
// First way to import
import { CircleLoader } from 'react-spinners';
interface IActualitesProps {
  limit: boolean
}

interface IActualitesState {
  actus: IActualite[],
  limit: boolean,
  isLoading: boolean
}

class Actualites extends React.Component<IActualitesProps, IActualitesState>
{

  /**
   *
   */
  constructor(props: IActualitesProps) {
    super(props);

    this.state = { actus: [], limit: props.limit, isLoading: true };
  }

  componentDidMount() {
    (this.state.limit ? ActualitesService.GetLastActus() : ActualitesService.GetAllActus()).then(actus => this.setState({ actus: actus, isLoading: false }));
  }

  render() {
    return (
      <div className={Styles.Actualites}>
        {/* {this.state.isLoading ?  <Container></Container> :  */}
        <Container>
          <CircleLoader
            css={"margin: auto; margin-top: 20px;"}
            sizeUnit={"vw"}
            size={20}
            color={'rgb(95, 156, 148)'}
            loading={this.state.isLoading}
          />
          <Row className="my-5">
            {this.state.actus.map(a => <Col key={a.Id} xs="12" md="4"> <ActualiteCard actu={a} /></Col>)}
          </Row>
          {this.state.limit ?
            <Row className="justify-content-center my-5">
              <Button color="primary" onClick={() => window.location.href = "/#/actualites"}>Voir toutes les actualités</Button>
            </Row>
            :
            null
          }


        </Container>
        {/* } */}
      </div>
    );
  }

}

export default Actualites;
